import React from 'react'
import { HeroContainer } from './Hero.style'

import HeroImage from "../../Assets/Images/LandingPage/hero_image_updated.png";

const HeroBanner = () => {
    return (
        <HeroContainer>
            <div className='hero_banner_section'>
                <div className="mygrid-container">
                    <div className="mygrid-row">
                        {/* Left Content */}
                        <div className="mygrid-col-lg-7 col-md-12">
                            <h1>Transforming Study <br /> Time into <span className='redfont'>Game Time</span></h1>
                            <h4 className='redfont'>Without Losing Instructional Control</h4>
                            <div className='hero_contents'>
                                <p>
                                    Subjects Master helps you reimagine study guide. Turn quizzes into
                                    games, boost student engagement, and track real-time performance, all
                                    while keeping full control over content, standards, and rigor.
                                </p>
                                <p>Teaching just got smarter (and a lot more fun).</p>
                            </div>
                        </div>

                        {/* Right Image */}
                        <div className="mygrid-col-lg-5 col-md-12">
                            <img
                                src={HeroImage}
                                alt="Subjects Master"
                                style={{ width: "100%", height: "auto" }}
                            />

                        </div>
                    </div>
                </div>
            </div>
        </HeroContainer>
    );
}

export default HeroBanner;
